import React from 'react'
import Card from './Card';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function NtwrkErrMsg({ errMsg, showReload }) {
    return (
        <Card>
            <div className='block text-center w-full p-6'>
                <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                    {errMsg}
                </div>
                {showReload && 
                <div className='text-center text-blue-200 mt-4'> 
                    <span className='hover:text-blue-300 cursor-pointer hover:underline' onClick={() => window.location.reload()}>
                        Try refresh
                    </span>
                </div>
                }
            </div>
        </Card>
)}